import React from 'react'
import './HomeSection.css'


const HomeSection = props => {
  return (
    <section className={`home-section ${props.homeClass}`}>
      {props.children}
    </section>
  );
}

export default HomeSection